import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/CallOutlined';

import styles from './styles';
import JobModal from '../JobModal';
import ActionsButton from '../ActionsButton';
import AvatarIcon from '../../icons/AvatarIcon';
import ModalController from '../ModalController';
import EnvelopeIcon from '../../icons/EnvelopeIcon';
import { openModal } from '../../store/actions/modal';
import { ACTIONS_BUTTON_TITLE } from '../JobsContent';
import JobStatus, { getJobStatusColorClass } from '../JobStatus';
import { JOB_STATUS_CODES, COLORS, VIEWABLE_FORM_MODES } from '../../constants';

const propTypes = {
  index: PropTypes.number.isRequired,
  job: PropTypes.shape({
    id: PropTypes.string,
    dateCreated: PropTypes.string,
    customerDetail: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
    status: PropTypes.string,
    statusCode: PropTypes.oneOf([
      JOB_STATUS_CODES.STATUS_01,
      JOB_STATUS_CODES.STATUS_02,
      JOB_STATUS_CODES.STATUS_03,
      JOB_STATUS_CODES.STATUS_04,
    ]),
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
    row1: PropTypes.string,
    row1Left: PropTypes.string,
    bullet: PropTypes.string,
    jobId: PropTypes.string,
    row1Right: PropTypes.string,
    row2: PropTypes.string,
    dateCreated: PropTypes.string,
    row3: PropTypes.string,
    customerName: PropTypes.string,
    row4: PropTypes.string,
    customerInfoText: PropTypes.string,
    customerEmail: PropTypes.string,
    customerPhone: PropTypes.string,
    phoneIcon: PropTypes.string,
    phoneLink: PropTypes.string,
  }).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      action: PropTypes.func,
    }),
  ),
  onOpenModal: PropTypes.func.isRequired,
  handleJobStatusChange: PropTypes.func.isRequired,
};

export const JobCard = props => {
  const {
    index,
    job,
    classes,
    actions,
    onOpenModal,
    handleJobStatusChange,
  } = props;

  const openViewJobModal = () => {
    const modalProps = {
      modalIndex: job.id,
      formMode: VIEWABLE_FORM_MODES.VIEWING,
      jobDetails: job,
    };
    onOpenModal('styledJobModal', modalProps);
  };

  return (
    <div className={classes.root}>
      <div className={classes.row1}>
        <div className={classes.row1Left}>
          <span
            className={classNames(
              classes.bullet,
              getJobStatusColorClass(classes, job.statusCode),
            )}
          >
            &bull;
          </span>
          <h2 className={classes.jobId}>
            <Button fullWidth color="primary" onClick={openViewJobModal}>
              ID: {job.id}
            </Button>
          </h2>
        </div>
        <div className={classes.row1Right}>
          {actions && (
            <ActionsButton
              id={`job-card-actions-button-${index}`}
              title={ACTIONS_BUTTON_TITLE}
              actions={actions}
            />
          )}
        </div>
      </div>
      <div className={classes.row2}>
        <div className={classes.dateCreated}>
          <span>Date created: </span>
          {job.dateCreated}
        </div>
      </div>
      <div className={classes.row3}>
        <div className={classes.customerName}>
          <AvatarIcon colorCode={COLORS.GREY_DARK} width={14} height={14} />
          <span className={classes.customerInfoText}>{`${
            job.customerDetail.firstName
          } ${job.customerDetail.lastName}`}</span>
        </div>
      </div>
      <div className={classes.row4}>
        <div className={classes.customerEmail}>
          <EnvelopeIcon width={14} height={14} />
          <span className={classes.customerInfoText}>
            {job.customerDetail.email}
          </span>
        </div>
        <div className={classes.customerPhone}>
          <PhoneIcon className={classes.phoneIcon} />
          <span className={classes.customerInfoText}>
            {(job.customerDetail.phoneNumber && (
              <a
                className={classes.phoneLink}
                href={`tel:${job.customerDetail.phoneNumber}`}
              >
                {job.customerDetail.phoneNumber}
              </a>
            )) || <>&ndash;</>}
          </span>
        </div>
      </div>
      <div className={classes.row5}>
        <div className={classes.status}>
          <JobStatus
            statusCode={job.statusCode}
            status={job.status}
            handleJobStatusChange={handleJobStatusChange}
            jobId={job.rawId}
          />
        </div>
      </div>
      <ModalController>
        <JobModal modalIndex={job.id} />
      </ModalController>
    </div>
  );
};

JobCard.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onOpenModal: (displayName, modalProps) =>
    dispatch(openModal(displayName, modalProps)),
});

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps,
  )(JobCard),
);
